export const chart_area_Opacity = {
  "name": "--pf-v5-chart-area--Opacity",
  "value": 0.3,
  "var": "var(--pf-v5-chart-area--Opacity, 0.3)"
};
export default chart_area_Opacity;